/**
 * ETAPA VISUAL 3 — STATUS DO CAMPEONATO COM UM SIGNIFICADO SÓ
 *
 * O sistema tem 3 estados de campeonato (`open`, `in_progress`, `finished`).
 * Antes cada tela mostrava isso de um jeito: uma faixa colorida decorativa no
 * topo do card (que não significava nada), um texto solto, ou a classe
 * `.status-*` — cada uma com uma cor.
 *
 * Aqui existe UMA tabela de tradução: rótulo em português, o selo (pílula com
 * ponto de cor) e a barra de status do topo do card. Verde = dá para se
 * inscrever, azul = está acontecendo, cinza = acabou.
 *
 * As classes são escritas por extenso de propósito: o Tailwind só emite a
 * classe que encontra no código-fonte, então nada de montar string por
 * interpolação.
 */
const ESTADOS = {
  open: {
    rotulo: 'Inscrições abertas',
    selo: 'selo selo--verde',
    barra: 'barra-status barra-status--aberto',
  },
  in_progress: {
    rotulo: 'Em andamento',
    selo: 'selo selo--azul',
    barra: 'barra-status barra-status--andamento',
  },
  finished: {
    rotulo: 'Finalizado',
    selo: 'selo selo--cinza',
    barra: 'barra-status barra-status--encerrado',
  },
};

const PADRAO = {
  rotulo: 'Sem status',
  selo: 'selo selo--cinza',
  barra: 'barra-status barra-status--encerrado',
};

/** Traduz o status do campeonato para rótulo + classes de selo e barra. */
export function statusCampeonato(status) {
  return ESTADOS[status] ?? { ...PADRAO, rotulo: status || PADRAO.rotulo };
}
